import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import BodyText from 'LuxKit/Typography/BodyText'
import config from 'constants/config'
import Logo from 'components/App/Header/Logo'
import { mediaQueryUp } from 'components/utils/breakpoint'
import getStaticPagesByType from 'lib/utils/getStaticPagesByType'
import TextLink from 'LuxKit/TextLink'
import { useHeaderStateObserver } from 'contexts/HeaderStateContext'
import Group from 'components/utils/Group'

const Root = styled.div`
  border-top: 1px solid ${props => props.theme.palette.neutral.default.six};
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
  background-color: ${props => props.theme.palette.neutral.default.eight};

  ${mediaQueryUp.tablet} {
    padding-top: ${rem(20)};
    padding-bottom: ${rem(20)};
  }
`

const Content = styled(LayoutContainer)`
  @media print {
    a[href]::after {
      content: none !important;
    }
  }
`

const FooterLogo = styled(Logo)`
  width: ${rem(144)};
  height: unset;
`

function MinimalFooter() {
  const intl = useIntl()
  const currentYear = new Date().getFullYear()

  const pageTypes = ['privacyPolicy', 'termsAndConditions', 'refundPolicy']

  const helpItems = getStaticPagesByType(pageTypes, true)

  const copyrightText = intl.formatMessage(
    {
      id: '4fcdDrLw5Z',
      defaultMessage: 'Copyright © 2017 - {year} {title}.',
      description: 'Copyright notice in footer with year and company title',
    },
    {
      year: currentYear,
      title: config.title,
    },
  )

  const footerDiv = useRef<HTMLDivElement>(null)
  useHeaderStateObserver('tripPlannerFooter', footerDiv)

  return <Root ref={footerDiv}>
    <Content size="xl">
      <Group
        direction="vertical"
        desktopDirection="horizontal"
        horizontalAlign="center"
        desktopHorizontalAlign="start"
        verticalAlign="center"
        gap={40}
      >
        <FooterLogo />
        <Group direction="vertical" desktopDirection="horizontal" desktopHorizontalAlign="space-between" gap={8}>
          <BodyText variant="medium">{copyrightText}</BodyText>
          <Group direction="horizontal" gap={12} wrap="wrap" horizontalAlign="center">
            {helpItems.map(item => <TextLink
              key={item.text}
              size="medium"
              weight="regular"
              to={item.url?.to}
              href={item.url?.href}
              target="_blank"
            >
              {item.text}
            </TextLink>)}
          </Group>
        </Group>
      </Group>
    </Content>
  </Root>
}

export default MinimalFooter
